import { apiRequest } from './index';

export const fetchPayscaleRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/payscales/' + id, {}, success, failure);
}

export const fetchPayscalesRequest = (areaId, effectiveDate, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(`/payscales?areaId=${areaId}&effectiveDate=${effectiveDate}`, {}, success, failure);
}

export const createPayscaleRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/payscales',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editPayscaleRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/payscales/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

const buildPayscaleOptions = payscale => ({
    value: payscale ? payscale._id : '',
    label: payscale ? `${payscale.level} - ${payscale.area.areaName}` : '',
    data: payscale
});

export const payscaleSelectOptionRequest = (success = (result = []) => {}, failure = (error) => {}) =>{
    fetch(process.env.REACT_APP_API_ENDPOINT + '/payscales')
        .then(response => response.json())
        .then(data => {
            const selectOptions = [];
            data.forEach((item) => {
                const option = buildPayscaleOptions(item);
                selectOptions.push(option);
            });
            success(selectOptions);
        })
        .catch(error =>{
            failure(error.status);
        });
}

export const deletePayscaleRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/payscales/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}

export const createPayscaleGroupRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/payscales/group',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const getEffectiveDateList = (areaId, success = (result = []) => {}, failure = (error) => {}) =>{
    if (typeof areaId === 'function') {
        failure = success;
        success = areaId;
        areaId = '';
    }

    const query = areaId ? `?areaId=${encodeURIComponent(areaId)}` : '';

    apiRequest(
        `/payscales/effective-date/list${query}`,
        { method: 'GET' },
        success,
        failure
    )
}
